export default __webpack_public_path__ + "static/slide3-es@2x-524a25bba594b0c57311fbe9a2d29e54.png";